<template>
    <div class="pages-body login-page p-d-flex p-flex-column login-bg-color">
        <div class="p-as-center p-mt-auto p-mb-auto">
            <div class="pages-panel p-d-flex p-flex-column">
                <div class="logo">
                    <img id="logo" src="assets/layout/images/arenacx_white_logo.png" alt="ultima-layout"
                        style="height: 6.25rem" />
                </div>
               
                <form>
                    <div v-if="deletedAccountError" class="error-message">
                    This account has been deactivated. Please contact support for assistance.
                </div>
                    <amplify-authenticator username-alias="email">

                        <amplify-sign-in slot="sign-in" username-alias="email" :formFields="loginFormFields"
                            hideSignUp></amplify-sign-in>
                    </amplify-authenticator>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
//import { onAuthUIStateChange } from '@aws-amplify/ui-components';
import { Auth, Hub } from 'aws-amplify';
import CurrentUserService from '../service/CurrentUserService';
import MarketplaceApiService from '../service/MarketplaceApiService';
import { RFP_CONTRIBUTOR_ROLE_KEY } from '../utilities/constants';

export default {
    name: 'AuthStateApp',
    data() {
        return {
            user: undefined,
            authState: undefined,
            unsubscribeAuth: undefined,
            signedIn: true,
            errorMessage: '',
            displayErrorMessage: false,
            loginFormFields: [
                {
                    type: 'email',
                    label: 'Username/Email',
                    placeholder: 'Enter email',
                    inputProps: { required: true, autocomplete: 'username' },
                },
                {
                    type: 'password',
                    label: 'Password',
                    placeholder: 'Enter password',
                    inputProps: { required: true, autocomplete: 'current-password' },
                },
            ],
            deletedAccountError: false,
        };
    },
    created() {
        window.localStorage.removeItem('accountId');
    },
    beforeCreate() {
        Hub.listen(
            'auth',
            async (data) => {
                switch (data.payload.event) {
                    case 'signIn':
                        await this.prepareAxios(data.payload);
                        this.displayErrorMessage = false;
                        console.log('user signed in');
                        break;
                    case 'signOut': {
                        console.log('user signed out');   
                        // Check if this is a manual logout
                        const manualLogoutFlag =
                            sessionStorage.getItem('manualLogout') ??
                            localStorage.getItem('manualLogout');
                        const isManualLogout = manualLogoutFlag === 'true';
                        if (isManualLogout) {
                            // Clear the manual logout flag
                            sessionStorage.removeItem('manualLogout');
                            localStorage.removeItem('manualLogout');
                            // For manual logout, don't preserve the current route
                            this.$router.push('/login');
                        } else {
                            // Preserve current route for redirect after login (automatic logout)
                            const currentPath = this.$route.fullPath;
                            // Only redirect if we're not already on login page to prevent loops
                            if (currentPath !== '/login' && !currentPath.includes('/login?')) {
                                this.$router.push(`/login?redirect=${currentPath}`);
                            } else {
                                this.$router.push('/login');
                            }
                        }
                        this.signedIn = true;
                        break;
                    }
                    case 'signIn_failure':
                        console.log('user sign in failed');
                        this.errorMessage = data.payload.data.message;
                        console.error('error msg', data.payload);
                        this.displayErrorMessage = true;
                        break;
                    case 'configured':
                        console.log('the Auth module is configured');
                }
            },

            Auth.currentAuthenticatedUser()
                .then(() => {
                    this.signedIn = true;
                })
                .catch(() => (this.signedIn = false))
        );
    },
    methods: {
        async prepareAxios(authPayload) {


            // Prepare axios for all API calls to Marketplace API
            const userService = new CurrentUserService();

            let cognitoUsername = authPayload.data.username;
            let jwtToken = authPayload.data.signInUserSession.idToken.jwtToken;
            let refreshToken = authPayload.data.signInUserSession.refreshToken.token;

            userService.jwt = jwtToken;

            userService.refreshToken = refreshToken;

            this.apiService = new MarketplaceApiService();
            let marketPlaceUser = await this.apiService.getUserDetails(cognitoUsername);
            userService.marketplaceUser = marketPlaceUser;

            console.log('MarketPlaceUser >>', userService.marketplaceUser);

            // Check for redirect URL in query parameters
            const redirectPath = this.$route.query.redirect;
            console.log('Login: Redirect path from query:', redirectPath);
            
            if (redirectPath) {
                console.log('Login: Redirecting to:', decodeURIComponent(redirectPath));
                // If there's a redirect URL, go there after login
                // But first check if it's not creating a loop back to login
                const decodedPath = decodeURIComponent(redirectPath);
                if (decodedPath !== '/login' && !decodedPath.includes('/login?')) {
                    console.log('Login: Redirecting to:', decodedPath);
                    this.$router.push(decodedPath);
                    return;
                } else {
                    console.log('Login: Preventing redirect loop, going to default route');
                }
            }

            // Check if user account is deleted for all user types
            if (userService.marketplaceUser && userService.marketplaceUser.isDeleted) {
                this.deletedAccountError = true;
                await Auth.signOut();
                return;
            }

            // Otherwise, proceed with normal role-based redirection
            if (userService.marketplaceUser.userRole.roleKey.startsWith('acx')) {
                this.$router.push('/');
            } else if (userService.marketplaceUser.userRole.roleKey.startsWith('partner')) {
                window.localStorage.setItem('accountId', userService.marketplaceUser.accountId);
                this.$router.push(`/partner/home`);
            } else if (userService.marketplaceUser.userRole.roleKey.startsWith('member')) {
                window.localStorage.setItem('accountId', userService.marketplaceUser.accountId);
                this.$router.push(`/member/home`);
            } else if (userService.marketplaceUser.userRole.roleKey === RFP_CONTRIBUTOR_ROLE_KEY) {
                window.localStorage.setItem('accountId', userService.marketplaceUser.accountId);
                this.$router.push(`/partner/opportunities`);
            } else if (userService.marketplaceUser.userRole.roleKey.startsWith('channel')) {
                window.localStorage.setItem('accountId', userService.marketplaceUser.accountId);
                this.$router.push(`/channel/home`);
            }

        },
    },
};
</script>

<style scoped>
amplify-authenticator {
    /* background: #e5e5e5; */

    --amplify-primary-color: #fd705e;
    --amplify-primary-tint: #fd705e;
    --amplify-primary-shade: #fd705e;

    /* --amplify-background-color: linear-gradient(135deg, #0F5B60, #57be92); */
    --container-display: inline;
    display: var(--container-display);
    min-height: 0;
}

.login-bg-color {
    background: #0f5b60;
    /* background: linear-gradient(135deg, #0F5B60, #E4EDD9, #57BE92); */
}

.login-logo-color {
    /* background: linear-gradient(180deg, #0f5b60, #e4edd9, #57be92); */
    background-color: #0f5b60;
}

.error-message {
    width:var(--width, 28.75rem);
    color: #ffffff;
    background-color: #ff4444;
    padding: 1rem;
    margin: 1rem 0;
    border-radius: 4px;
    text-align: center;
}
</style>
